/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AdvisorCacheGroup } from '../models';
// @ts-ignore
import type { AdvisorDatabase } from '../models';
// @ts-ignore
import type { AdvisorDatabaseInstance } from '../models';
// @ts-ignore
import type { AdvisorRecommendationDetail } from '../models';
// @ts-ignore
import type { BatchGetAdvisorDatabaseStatsRequest } from '../models';
// @ts-ignore
import type { BatchGetAdvisorDatabaseStatsResponse } from '../models';
// @ts-ignore
import type { ListAdvisorCacheGroupsResponse } from '../models';
// @ts-ignore
import type { ListAdvisorDatabaseInstancesResponse } from '../models';
// @ts-ignore
import type { ListAdvisorDatabasesResponse } from '../models';
// @ts-ignore
import type { ListAdvisorRecommendationsResponse } from '../models';
// @ts-ignore
import type { ListTopRecommendationsResponse } from '../models';
// @ts-ignore
import type { ResendAdvisorValidationRequestRequestOptions } from '../models';
// @ts-ignore
import type { ResendAdvisorValidationRequestResponse } from '../models';
// @ts-ignore
import type { ResetAdvisorRecommendationsResponse } from '../models';
// @ts-ignore
import type { Status } from '../models';
/**
 * AdvisorAPIApi - axios parameter creator
 * @export
 */
export const AdvisorAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns recommendation stats for the given database IDs in a single batch call.
         * @summary Batch get advisor stats for databases
         * @param {string} organizationId Organization identifier
         * @param {BatchGetAdvisorDatabaseStatsRequest} batchGetAdvisorDatabaseStatsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advisorAPIBatchGetAdvisorDatabaseStats: async (organizationId: string, batchGetAdvisorDatabaseStatsRequest: BatchGetAdvisorDatabaseStatsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('advisorAPIBatchGetAdvisorDatabaseStats', 'organizationId', organizationId)
            // verify required parameter 'batchGetAdvisorDatabaseStatsRequest' is not null or undefined
            assertParamExists('advisorAPIBatchGetAdvisorDatabaseStats', 'batchGetAdvisorDatabaseStatsRequest', batchGetAdvisorDatabaseStatsRequest)
            const localVarPath = `/database-optimizer/advisor/v1alpha/organizations/{organizationId}/databases:batchGetStats`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchGetAdvisorDatabaseStatsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Close an advisor recommendation (query or index — kind inferred from ID)
         * @summary Close an advisor recommendation
         * @param {string} organizationId Organization identifier
         * @param {string} databaseId Database identifier
         * @param {string} id Recommendation identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advisorAPICloseAdvisorRecommendation: async (organizationId: string, databaseId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('advisorAPICloseAdvisorRecommendation', 'organizationId', organizationId)
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('advisorAPICloseAdvisorRecommendation', 'databaseId', databaseId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('advisorAPICloseAdvisorRecommendation', 'id', id)
            const localVarPath = `/database-optimizer/advisor/v1alpha/organizations/{organizationId}/databases/{databaseId}/recommendations/{id}:close`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single cache group with combined query and index recommendation statistics
         * @summary Get cache group with combined advisor statistics
         * @param {string} organizationId Organization identifier
         * @param {string} id Cache group identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advisorAPIGetAdvisorCacheGroup: async (organizationId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('advisorAPIGetAdvisorCacheGroup', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('advisorAPIGetAdvisorCacheGroup', 'id', id)
            const localVarPath = `/database-optimizer/advisor/v1alpha/organizations/{organizationId}/cache-groups/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single database with combined query and index recommendation statistics
         * @summary Get database with combined advisor statistics
         * @param {string} organizationId Organization identifier
         * @param {string} id Database identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advisorAPIGetAdvisorDatabase: async (organizationId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('advisorAPIGetAdvisorDatabase', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('advisorAPIGetAdvisorDatabase', 'id', id)
            const localVarPath = `/database-optimizer/advisor/v1alpha/organizations/{organizationId}/databases/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns db-agent status for a single database instance in the organization.
         * @summary Get database instance with advisor agent status
         * @param {string} organizationId Organization identifier
         * @param {string} id Database instance identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advisorAPIGetAdvisorDatabaseInstance: async (organizationId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('advisorAPIGetAdvisorDatabaseInstance', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('advisorAPIGetAdvisorDatabaseInstance', 'id', id)
            const localVarPath = `/database-optimizer/advisor/v1alpha/organizations/{organizationId}/database-instances/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single performance recommendation with detailed information
         * @summary Get advisor recommendation details
         * @param {string} organizationId Organization identifier
         * @param {string} databaseId Database identifier
         * @param {string} id Recommendation identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advisorAPIGetAdvisorRecommendationDetail: async (organizationId: string, databaseId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('advisorAPIGetAdvisorRecommendationDetail', 'organizationId', organizationId)
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('advisorAPIGetAdvisorRecommendationDetail', 'databaseId', databaseId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('advisorAPIGetAdvisorRecommendationDetail', 'id', id)
            const localVarPath = `/database-optimizer/advisor/v1alpha/organizations/{organizationId}/databases/{databaseId}/recommendations/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List cache groups with combined query and index recommendation statistics
         * @summary List cache groups with combined advisor statistics
         * @param {string} organizationId Organization identifier
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advisorAPIListAdvisorCacheGroups: async (organizationId: string, pageLimit?: string, pageCursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('advisorAPIListAdvisorCacheGroups', 'organizationId', organizationId)
            const localVarPath = `/database-optimizer/advisor/v1alpha/organizations/{organizationId}/cache-groups`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns db-agent statuses for all database instances in the organization.
         * @summary List database instances with advisor agent status
         * @param {string} organizationId Organization identifier
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advisorAPIListAdvisorDatabaseInstances: async (organizationId: string, pageLimit?: string, pageCursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('advisorAPIListAdvisorDatabaseInstances', 'organizationId', organizationId)
            const localVarPath = `/database-optimizer/advisor/v1alpha/organizations/{organizationId}/database-instances`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List databases within a cache group with combined query and index recommendation statistics
         * @summary List databases with combined advisor statistics
         * @param {string} organizationId Organization identifier
         * @param {string} cacheGroupId Cache group identifier
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advisorAPIListAdvisorDatabases: async (organizationId: string, cacheGroupId: string, pageLimit?: string, pageCursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('advisorAPIListAdvisorDatabases', 'organizationId', organizationId)
            // verify required parameter 'cacheGroupId' is not null or undefined
            assertParamExists('advisorAPIListAdvisorDatabases', 'cacheGroupId', cacheGroupId)
            const localVarPath = `/database-optimizer/advisor/v1alpha/organizations/{organizationId}/cache-groups/{cacheGroupId}/databases`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"cacheGroupId"}}`, encodeURIComponent(String(cacheGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List combined query and index recommendations for a database
         * @summary List combined query and index advisor recommendations
         * @param {string} organizationId Organization identifier
         * @param {string} databaseId Database identifier
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {Array<AdvisorAPIListAdvisorRecommendationsKindsEnum>} [kinds] Filter by recommendation kind — omit to return both query and index
         * @param {Array<AdvisorAPIListAdvisorRecommendationsCategoriesEnum>} [categories] Filter by category (applies to query recommendations only)
         * @param {Array<AdvisorAPIListAdvisorRecommendationsImpactsEnum>} [impacts] Filter by impact (applies to query recommendations only)
         * @param {Array<AdvisorAPIListAdvisorRecommendationsStatusesEnum>} [statuses] Filter by status
         * @param {Array<AdvisorAPIListAdvisorRecommendationsValidationStatusesEnum>} [validationStatuses] Filter by validation status — omit to return all regardless of validation status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advisorAPIListAdvisorRecommendations: async (organizationId: string, databaseId: string, pageLimit?: string, pageCursor?: string, kinds?: Array<AdvisorAPIListAdvisorRecommendationsKindsEnum>, categories?: Array<AdvisorAPIListAdvisorRecommendationsCategoriesEnum>, impacts?: Array<AdvisorAPIListAdvisorRecommendationsImpactsEnum>, statuses?: Array<AdvisorAPIListAdvisorRecommendationsStatusesEnum>, validationStatuses?: Array<AdvisorAPIListAdvisorRecommendationsValidationStatusesEnum>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('advisorAPIListAdvisorRecommendations', 'organizationId', organizationId)
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('advisorAPIListAdvisorRecommendations', 'databaseId', databaseId)
            const localVarPath = `/database-optimizer/advisor/v1alpha/organizations/{organizationId}/databases/{databaseId}/recommendations`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }

            if (kinds) {
                localVarQueryParameter['kinds'] = kinds;
            }

            if (categories) {
                localVarQueryParameter['categories'] = categories;
            }

            if (impacts) {
                localVarQueryParameter['impacts'] = impacts;
            }

            if (statuses) {
                localVarQueryParameter['statuses'] = statuses;
            }

            if (validationStatuses) {
                localVarQueryParameter['validationStatuses'] = validationStatuses;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the top open recommendations (query and index) across all v2  database instances in the organization, ordered by impact desc then  affected db time desc. Polyscale enriches the results with instance and  database names.
         * @summary List top recommendations across the organization
         * @param {string} organizationId Organization identifier
         * @param {number} [limit] Maximum number of recommendations to return. Defaults to 5.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advisorAPIListTopRecommendations: async (organizationId: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('advisorAPIListTopRecommendations', 'organizationId', organizationId)
            const localVarPath = `/database-optimizer/advisor/v1alpha/organizations/{organizationId}/top-recommendations`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Internal-only: mark the DB agent for a cache group as uninstalled (soft  delete). Called by polyscale once the db-agent\'s Helm release has been torn  down, so that the agent\'s status resolves to NOT_INSTALLED instead of ERROR.  Not exposed to customers via the public API.
         * @summary Internal: Mark the DB agent for a cache group as uninstalled
         * @param {string} organizationId Organization identifier
         * @param {string} id Database instance identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advisorAPIMarkAdvisorDBAgentUninstalled: async (organizationId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('advisorAPIMarkAdvisorDBAgentUninstalled', 'organizationId', organizationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('advisorAPIMarkAdvisorDBAgentUninstalled', 'id', id)
            const localVarPath = `/database-optimizer/advisor/v1alpha/organizations/{organizationId}/database-instances/{id}:markDbAgentUninstalled`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reopen a closed advisor recommendation (query or index — kind inferred from ID)
         * @summary Reopen a closed advisor recommendation
         * @param {string} organizationId Organization identifier
         * @param {string} databaseId Database identifier
         * @param {string} id Recommendation identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advisorAPIReopenAdvisorRecommendation: async (organizationId: string, databaseId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('advisorAPIReopenAdvisorRecommendation', 'organizationId', organizationId)
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('advisorAPIReopenAdvisorRecommendation', 'databaseId', databaseId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('advisorAPIReopenAdvisorRecommendation', 'id', id)
            const localVarPath = `/database-optimizer/advisor/v1alpha/organizations/{organizationId}/databases/{databaseId}/recommendations/{id}:reopen`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resend validation request for advisor recommendations that don\'t already have a validation result
         * @summary Resend validation request for advisor recommendations that don\'t already have a validation result
         * @param {string} organizationId Organization identifier
         * @param {string} databaseId Database identifier
         * @param {ResendAdvisorValidationRequestRequestOptions} resendAdvisorValidationRequestRequestOptions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advisorAPIResendAdvisorValidationRequest: async (organizationId: string, databaseId: string, resendAdvisorValidationRequestRequestOptions: ResendAdvisorValidationRequestRequestOptions, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('advisorAPIResendAdvisorValidationRequest', 'organizationId', organizationId)
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('advisorAPIResendAdvisorValidationRequest', 'databaseId', databaseId)
            // verify required parameter 'resendAdvisorValidationRequestRequestOptions' is not null or undefined
            assertParamExists('advisorAPIResendAdvisorValidationRequest', 'resendAdvisorValidationRequestRequestOptions', resendAdvisorValidationRequestRequestOptions)
            const localVarPath = `/database-optimizer/advisor/v1alpha/organizations/{organizationId}/databases/{databaseId}/validation-requests:resend`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resendAdvisorValidationRequestRequestOptions, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reset all advisor recommendations (query + index) for a database
         * @summary Reset all advisor recommendations for a database
         * @param {string} organizationId Organization identifier
         * @param {string} databaseId Database identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advisorAPIResetAdvisorRecommendations: async (organizationId: string, databaseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('advisorAPIResetAdvisorRecommendations', 'organizationId', organizationId)
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('advisorAPIResetAdvisorRecommendations', 'databaseId', databaseId)
            const localVarPath = `/database-optimizer/advisor/v1alpha/organizations/{organizationId}/databases/{databaseId}/recommendations:reset`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdvisorAPIApi - functional programming interface
 * @export
 */
export const AdvisorAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdvisorAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns recommendation stats for the given database IDs in a single batch call.
         * @summary Batch get advisor stats for databases
         * @param {string} organizationId Organization identifier
         * @param {BatchGetAdvisorDatabaseStatsRequest} batchGetAdvisorDatabaseStatsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async advisorAPIBatchGetAdvisorDatabaseStats(organizationId: string, batchGetAdvisorDatabaseStatsRequest: BatchGetAdvisorDatabaseStatsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BatchGetAdvisorDatabaseStatsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.advisorAPIBatchGetAdvisorDatabaseStats(organizationId, batchGetAdvisorDatabaseStatsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdvisorAPIApi.advisorAPIBatchGetAdvisorDatabaseStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Close an advisor recommendation (query or index — kind inferred from ID)
         * @summary Close an advisor recommendation
         * @param {string} organizationId Organization identifier
         * @param {string} databaseId Database identifier
         * @param {string} id Recommendation identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async advisorAPICloseAdvisorRecommendation(organizationId: string, databaseId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.advisorAPICloseAdvisorRecommendation(organizationId, databaseId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdvisorAPIApi.advisorAPICloseAdvisorRecommendation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single cache group with combined query and index recommendation statistics
         * @summary Get cache group with combined advisor statistics
         * @param {string} organizationId Organization identifier
         * @param {string} id Cache group identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async advisorAPIGetAdvisorCacheGroup(organizationId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdvisorCacheGroup>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.advisorAPIGetAdvisorCacheGroup(organizationId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdvisorAPIApi.advisorAPIGetAdvisorCacheGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single database with combined query and index recommendation statistics
         * @summary Get database with combined advisor statistics
         * @param {string} organizationId Organization identifier
         * @param {string} id Database identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async advisorAPIGetAdvisorDatabase(organizationId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdvisorDatabase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.advisorAPIGetAdvisorDatabase(organizationId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdvisorAPIApi.advisorAPIGetAdvisorDatabase']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns db-agent status for a single database instance in the organization.
         * @summary Get database instance with advisor agent status
         * @param {string} organizationId Organization identifier
         * @param {string} id Database instance identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async advisorAPIGetAdvisorDatabaseInstance(organizationId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdvisorDatabaseInstance>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.advisorAPIGetAdvisorDatabaseInstance(organizationId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdvisorAPIApi.advisorAPIGetAdvisorDatabaseInstance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single performance recommendation with detailed information
         * @summary Get advisor recommendation details
         * @param {string} organizationId Organization identifier
         * @param {string} databaseId Database identifier
         * @param {string} id Recommendation identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async advisorAPIGetAdvisorRecommendationDetail(organizationId: string, databaseId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdvisorRecommendationDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.advisorAPIGetAdvisorRecommendationDetail(organizationId, databaseId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdvisorAPIApi.advisorAPIGetAdvisorRecommendationDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List cache groups with combined query and index recommendation statistics
         * @summary List cache groups with combined advisor statistics
         * @param {string} organizationId Organization identifier
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async advisorAPIListAdvisorCacheGroups(organizationId: string, pageLimit?: string, pageCursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListAdvisorCacheGroupsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.advisorAPIListAdvisorCacheGroups(organizationId, pageLimit, pageCursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdvisorAPIApi.advisorAPIListAdvisorCacheGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns db-agent statuses for all database instances in the organization.
         * @summary List database instances with advisor agent status
         * @param {string} organizationId Organization identifier
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async advisorAPIListAdvisorDatabaseInstances(organizationId: string, pageLimit?: string, pageCursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListAdvisorDatabaseInstancesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.advisorAPIListAdvisorDatabaseInstances(organizationId, pageLimit, pageCursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdvisorAPIApi.advisorAPIListAdvisorDatabaseInstances']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List databases within a cache group with combined query and index recommendation statistics
         * @summary List databases with combined advisor statistics
         * @param {string} organizationId Organization identifier
         * @param {string} cacheGroupId Cache group identifier
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async advisorAPIListAdvisorDatabases(organizationId: string, cacheGroupId: string, pageLimit?: string, pageCursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListAdvisorDatabasesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.advisorAPIListAdvisorDatabases(organizationId, cacheGroupId, pageLimit, pageCursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdvisorAPIApi.advisorAPIListAdvisorDatabases']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List combined query and index recommendations for a database
         * @summary List combined query and index advisor recommendations
         * @param {string} organizationId Organization identifier
         * @param {string} databaseId Database identifier
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {Array<AdvisorAPIListAdvisorRecommendationsKindsEnum>} [kinds] Filter by recommendation kind — omit to return both query and index
         * @param {Array<AdvisorAPIListAdvisorRecommendationsCategoriesEnum>} [categories] Filter by category (applies to query recommendations only)
         * @param {Array<AdvisorAPIListAdvisorRecommendationsImpactsEnum>} [impacts] Filter by impact (applies to query recommendations only)
         * @param {Array<AdvisorAPIListAdvisorRecommendationsStatusesEnum>} [statuses] Filter by status
         * @param {Array<AdvisorAPIListAdvisorRecommendationsValidationStatusesEnum>} [validationStatuses] Filter by validation status — omit to return all regardless of validation status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async advisorAPIListAdvisorRecommendations(organizationId: string, databaseId: string, pageLimit?: string, pageCursor?: string, kinds?: Array<AdvisorAPIListAdvisorRecommendationsKindsEnum>, categories?: Array<AdvisorAPIListAdvisorRecommendationsCategoriesEnum>, impacts?: Array<AdvisorAPIListAdvisorRecommendationsImpactsEnum>, statuses?: Array<AdvisorAPIListAdvisorRecommendationsStatusesEnum>, validationStatuses?: Array<AdvisorAPIListAdvisorRecommendationsValidationStatusesEnum>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListAdvisorRecommendationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.advisorAPIListAdvisorRecommendations(organizationId, databaseId, pageLimit, pageCursor, kinds, categories, impacts, statuses, validationStatuses, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdvisorAPIApi.advisorAPIListAdvisorRecommendations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the top open recommendations (query and index) across all v2  database instances in the organization, ordered by impact desc then  affected db time desc. Polyscale enriches the results with instance and  database names.
         * @summary List top recommendations across the organization
         * @param {string} organizationId Organization identifier
         * @param {number} [limit] Maximum number of recommendations to return. Defaults to 5.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async advisorAPIListTopRecommendations(organizationId: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTopRecommendationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.advisorAPIListTopRecommendations(organizationId, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdvisorAPIApi.advisorAPIListTopRecommendations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Internal-only: mark the DB agent for a cache group as uninstalled (soft  delete). Called by polyscale once the db-agent\'s Helm release has been torn  down, so that the agent\'s status resolves to NOT_INSTALLED instead of ERROR.  Not exposed to customers via the public API.
         * @summary Internal: Mark the DB agent for a cache group as uninstalled
         * @param {string} organizationId Organization identifier
         * @param {string} id Database instance identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async advisorAPIMarkAdvisorDBAgentUninstalled(organizationId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.advisorAPIMarkAdvisorDBAgentUninstalled(organizationId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdvisorAPIApi.advisorAPIMarkAdvisorDBAgentUninstalled']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reopen a closed advisor recommendation (query or index — kind inferred from ID)
         * @summary Reopen a closed advisor recommendation
         * @param {string} organizationId Organization identifier
         * @param {string} databaseId Database identifier
         * @param {string} id Recommendation identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async advisorAPIReopenAdvisorRecommendation(organizationId: string, databaseId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.advisorAPIReopenAdvisorRecommendation(organizationId, databaseId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdvisorAPIApi.advisorAPIReopenAdvisorRecommendation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Resend validation request for advisor recommendations that don\'t already have a validation result
         * @summary Resend validation request for advisor recommendations that don\'t already have a validation result
         * @param {string} organizationId Organization identifier
         * @param {string} databaseId Database identifier
         * @param {ResendAdvisorValidationRequestRequestOptions} resendAdvisorValidationRequestRequestOptions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async advisorAPIResendAdvisorValidationRequest(organizationId: string, databaseId: string, resendAdvisorValidationRequestRequestOptions: ResendAdvisorValidationRequestRequestOptions, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResendAdvisorValidationRequestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.advisorAPIResendAdvisorValidationRequest(organizationId, databaseId, resendAdvisorValidationRequestRequestOptions, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdvisorAPIApi.advisorAPIResendAdvisorValidationRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reset all advisor recommendations (query + index) for a database
         * @summary Reset all advisor recommendations for a database
         * @param {string} organizationId Organization identifier
         * @param {string} databaseId Database identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async advisorAPIResetAdvisorRecommendations(organizationId: string, databaseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResetAdvisorRecommendationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.advisorAPIResetAdvisorRecommendations(organizationId, databaseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdvisorAPIApi.advisorAPIResetAdvisorRecommendations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdvisorAPIApi - factory interface
 * @export
 */
export const AdvisorAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdvisorAPIApiFp(configuration)
    return {
        /**
         * Returns recommendation stats for the given database IDs in a single batch call.
         * @summary Batch get advisor stats for databases
         * @param {AdvisorAPIApiAdvisorAPIBatchGetAdvisorDatabaseStatsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advisorAPIBatchGetAdvisorDatabaseStats(requestParameters: AdvisorAPIApiAdvisorAPIBatchGetAdvisorDatabaseStatsRequest, options?: RawAxiosRequestConfig): AxiosPromise<BatchGetAdvisorDatabaseStatsResponse> {
            return localVarFp.advisorAPIBatchGetAdvisorDatabaseStats(requestParameters.organizationId, requestParameters.batchGetAdvisorDatabaseStatsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Close an advisor recommendation (query or index — kind inferred from ID)
         * @summary Close an advisor recommendation
         * @param {AdvisorAPIApiAdvisorAPICloseAdvisorRecommendationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advisorAPICloseAdvisorRecommendation(requestParameters: AdvisorAPIApiAdvisorAPICloseAdvisorRecommendationRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.advisorAPICloseAdvisorRecommendation(requestParameters.organizationId, requestParameters.databaseId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single cache group with combined query and index recommendation statistics
         * @summary Get cache group with combined advisor statistics
         * @param {AdvisorAPIApiAdvisorAPIGetAdvisorCacheGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advisorAPIGetAdvisorCacheGroup(requestParameters: AdvisorAPIApiAdvisorAPIGetAdvisorCacheGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdvisorCacheGroup> {
            return localVarFp.advisorAPIGetAdvisorCacheGroup(requestParameters.organizationId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single database with combined query and index recommendation statistics
         * @summary Get database with combined advisor statistics
         * @param {AdvisorAPIApiAdvisorAPIGetAdvisorDatabaseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advisorAPIGetAdvisorDatabase(requestParameters: AdvisorAPIApiAdvisorAPIGetAdvisorDatabaseRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdvisorDatabase> {
            return localVarFp.advisorAPIGetAdvisorDatabase(requestParameters.organizationId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns db-agent status for a single database instance in the organization.
         * @summary Get database instance with advisor agent status
         * @param {AdvisorAPIApiAdvisorAPIGetAdvisorDatabaseInstanceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advisorAPIGetAdvisorDatabaseInstance(requestParameters: AdvisorAPIApiAdvisorAPIGetAdvisorDatabaseInstanceRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdvisorDatabaseInstance> {
            return localVarFp.advisorAPIGetAdvisorDatabaseInstance(requestParameters.organizationId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single performance recommendation with detailed information
         * @summary Get advisor recommendation details
         * @param {AdvisorAPIApiAdvisorAPIGetAdvisorRecommendationDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advisorAPIGetAdvisorRecommendationDetail(requestParameters: AdvisorAPIApiAdvisorAPIGetAdvisorRecommendationDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdvisorRecommendationDetail> {
            return localVarFp.advisorAPIGetAdvisorRecommendationDetail(requestParameters.organizationId, requestParameters.databaseId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * List cache groups with combined query and index recommendation statistics
         * @summary List cache groups with combined advisor statistics
         * @param {AdvisorAPIApiAdvisorAPIListAdvisorCacheGroupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advisorAPIListAdvisorCacheGroups(requestParameters: AdvisorAPIApiAdvisorAPIListAdvisorCacheGroupsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListAdvisorCacheGroupsResponse> {
            return localVarFp.advisorAPIListAdvisorCacheGroups(requestParameters.organizationId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns db-agent statuses for all database instances in the organization.
         * @summary List database instances with advisor agent status
         * @param {AdvisorAPIApiAdvisorAPIListAdvisorDatabaseInstancesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advisorAPIListAdvisorDatabaseInstances(requestParameters: AdvisorAPIApiAdvisorAPIListAdvisorDatabaseInstancesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListAdvisorDatabaseInstancesResponse> {
            return localVarFp.advisorAPIListAdvisorDatabaseInstances(requestParameters.organizationId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(axios, basePath));
        },
        /**
         * List databases within a cache group with combined query and index recommendation statistics
         * @summary List databases with combined advisor statistics
         * @param {AdvisorAPIApiAdvisorAPIListAdvisorDatabasesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advisorAPIListAdvisorDatabases(requestParameters: AdvisorAPIApiAdvisorAPIListAdvisorDatabasesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListAdvisorDatabasesResponse> {
            return localVarFp.advisorAPIListAdvisorDatabases(requestParameters.organizationId, requestParameters.cacheGroupId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(axios, basePath));
        },
        /**
         * List combined query and index recommendations for a database
         * @summary List combined query and index advisor recommendations
         * @param {AdvisorAPIApiAdvisorAPIListAdvisorRecommendationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advisorAPIListAdvisorRecommendations(requestParameters: AdvisorAPIApiAdvisorAPIListAdvisorRecommendationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListAdvisorRecommendationsResponse> {
            return localVarFp.advisorAPIListAdvisorRecommendations(requestParameters.organizationId, requestParameters.databaseId, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.kinds, requestParameters.categories, requestParameters.impacts, requestParameters.statuses, requestParameters.validationStatuses, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the top open recommendations (query and index) across all v2  database instances in the organization, ordered by impact desc then  affected db time desc. Polyscale enriches the results with instance and  database names.
         * @summary List top recommendations across the organization
         * @param {AdvisorAPIApiAdvisorAPIListTopRecommendationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advisorAPIListTopRecommendations(requestParameters: AdvisorAPIApiAdvisorAPIListTopRecommendationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListTopRecommendationsResponse> {
            return localVarFp.advisorAPIListTopRecommendations(requestParameters.organizationId, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Internal-only: mark the DB agent for a cache group as uninstalled (soft  delete). Called by polyscale once the db-agent\'s Helm release has been torn  down, so that the agent\'s status resolves to NOT_INSTALLED instead of ERROR.  Not exposed to customers via the public API.
         * @summary Internal: Mark the DB agent for a cache group as uninstalled
         * @param {AdvisorAPIApiAdvisorAPIMarkAdvisorDBAgentUninstalledRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advisorAPIMarkAdvisorDBAgentUninstalled(requestParameters: AdvisorAPIApiAdvisorAPIMarkAdvisorDBAgentUninstalledRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.advisorAPIMarkAdvisorDBAgentUninstalled(requestParameters.organizationId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Reopen a closed advisor recommendation (query or index — kind inferred from ID)
         * @summary Reopen a closed advisor recommendation
         * @param {AdvisorAPIApiAdvisorAPIReopenAdvisorRecommendationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advisorAPIReopenAdvisorRecommendation(requestParameters: AdvisorAPIApiAdvisorAPIReopenAdvisorRecommendationRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.advisorAPIReopenAdvisorRecommendation(requestParameters.organizationId, requestParameters.databaseId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Resend validation request for advisor recommendations that don\'t already have a validation result
         * @summary Resend validation request for advisor recommendations that don\'t already have a validation result
         * @param {AdvisorAPIApiAdvisorAPIResendAdvisorValidationRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advisorAPIResendAdvisorValidationRequest(requestParameters: AdvisorAPIApiAdvisorAPIResendAdvisorValidationRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResendAdvisorValidationRequestResponse> {
            return localVarFp.advisorAPIResendAdvisorValidationRequest(requestParameters.organizationId, requestParameters.databaseId, requestParameters.resendAdvisorValidationRequestRequestOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * Reset all advisor recommendations (query + index) for a database
         * @summary Reset all advisor recommendations for a database
         * @param {AdvisorAPIApiAdvisorAPIResetAdvisorRecommendationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advisorAPIResetAdvisorRecommendations(requestParameters: AdvisorAPIApiAdvisorAPIResetAdvisorRecommendationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResetAdvisorRecommendationsResponse> {
            return localVarFp.advisorAPIResetAdvisorRecommendations(requestParameters.organizationId, requestParameters.databaseId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for advisorAPIBatchGetAdvisorDatabaseStats operation in AdvisorAPIApi.
 * @export
 * @interface AdvisorAPIApiAdvisorAPIBatchGetAdvisorDatabaseStatsRequest
 */
export interface AdvisorAPIApiAdvisorAPIBatchGetAdvisorDatabaseStatsRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof AdvisorAPIApiAdvisorAPIBatchGetAdvisorDatabaseStats
     */
    readonly organizationId: string

    /**
     * 
     * @type {BatchGetAdvisorDatabaseStatsRequest}
     * @memberof AdvisorAPIApiAdvisorAPIBatchGetAdvisorDatabaseStats
     */
    readonly batchGetAdvisorDatabaseStatsRequest: BatchGetAdvisorDatabaseStatsRequest
}

/**
 * Request parameters for advisorAPICloseAdvisorRecommendation operation in AdvisorAPIApi.
 * @export
 * @interface AdvisorAPIApiAdvisorAPICloseAdvisorRecommendationRequest
 */
export interface AdvisorAPIApiAdvisorAPICloseAdvisorRecommendationRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof AdvisorAPIApiAdvisorAPICloseAdvisorRecommendation
     */
    readonly organizationId: string

    /**
     * Database identifier
     * @type {string}
     * @memberof AdvisorAPIApiAdvisorAPICloseAdvisorRecommendation
     */
    readonly databaseId: string

    /**
     * Recommendation identifier
     * @type {string}
     * @memberof AdvisorAPIApiAdvisorAPICloseAdvisorRecommendation
     */
    readonly id: string
}

/**
 * Request parameters for advisorAPIGetAdvisorCacheGroup operation in AdvisorAPIApi.
 * @export
 * @interface AdvisorAPIApiAdvisorAPIGetAdvisorCacheGroupRequest
 */
export interface AdvisorAPIApiAdvisorAPIGetAdvisorCacheGroupRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof AdvisorAPIApiAdvisorAPIGetAdvisorCacheGroup
     */
    readonly organizationId: string

    /**
     * Cache group identifier
     * @type {string}
     * @memberof AdvisorAPIApiAdvisorAPIGetAdvisorCacheGroup
     */
    readonly id: string
}

/**
 * Request parameters for advisorAPIGetAdvisorDatabase operation in AdvisorAPIApi.
 * @export
 * @interface AdvisorAPIApiAdvisorAPIGetAdvisorDatabaseRequest
 */
export interface AdvisorAPIApiAdvisorAPIGetAdvisorDatabaseRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof AdvisorAPIApiAdvisorAPIGetAdvisorDatabase
     */
    readonly organizationId: string

    /**
     * Database identifier
     * @type {string}
     * @memberof AdvisorAPIApiAdvisorAPIGetAdvisorDatabase
     */
    readonly id: string
}

/**
 * Request parameters for advisorAPIGetAdvisorDatabaseInstance operation in AdvisorAPIApi.
 * @export
 * @interface AdvisorAPIApiAdvisorAPIGetAdvisorDatabaseInstanceRequest
 */
export interface AdvisorAPIApiAdvisorAPIGetAdvisorDatabaseInstanceRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof AdvisorAPIApiAdvisorAPIGetAdvisorDatabaseInstance
     */
    readonly organizationId: string

    /**
     * Database instance identifier
     * @type {string}
     * @memberof AdvisorAPIApiAdvisorAPIGetAdvisorDatabaseInstance
     */
    readonly id: string
}

/**
 * Request parameters for advisorAPIGetAdvisorRecommendationDetail operation in AdvisorAPIApi.
 * @export
 * @interface AdvisorAPIApiAdvisorAPIGetAdvisorRecommendationDetailRequest
 */
export interface AdvisorAPIApiAdvisorAPIGetAdvisorRecommendationDetailRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof AdvisorAPIApiAdvisorAPIGetAdvisorRecommendationDetail
     */
    readonly organizationId: string

    /**
     * Database identifier
     * @type {string}
     * @memberof AdvisorAPIApiAdvisorAPIGetAdvisorRecommendationDetail
     */
    readonly databaseId: string

    /**
     * Recommendation identifier
     * @type {string}
     * @memberof AdvisorAPIApiAdvisorAPIGetAdvisorRecommendationDetail
     */
    readonly id: string
}

/**
 * Request parameters for advisorAPIListAdvisorCacheGroups operation in AdvisorAPIApi.
 * @export
 * @interface AdvisorAPIApiAdvisorAPIListAdvisorCacheGroupsRequest
 */
export interface AdvisorAPIApiAdvisorAPIListAdvisorCacheGroupsRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof AdvisorAPIApiAdvisorAPIListAdvisorCacheGroups
     */
    readonly organizationId: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof AdvisorAPIApiAdvisorAPIListAdvisorCacheGroups
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof AdvisorAPIApiAdvisorAPIListAdvisorCacheGroups
     */
    readonly pageCursor?: string
}

/**
 * Request parameters for advisorAPIListAdvisorDatabaseInstances operation in AdvisorAPIApi.
 * @export
 * @interface AdvisorAPIApiAdvisorAPIListAdvisorDatabaseInstancesRequest
 */
export interface AdvisorAPIApiAdvisorAPIListAdvisorDatabaseInstancesRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof AdvisorAPIApiAdvisorAPIListAdvisorDatabaseInstances
     */
    readonly organizationId: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof AdvisorAPIApiAdvisorAPIListAdvisorDatabaseInstances
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof AdvisorAPIApiAdvisorAPIListAdvisorDatabaseInstances
     */
    readonly pageCursor?: string
}

/**
 * Request parameters for advisorAPIListAdvisorDatabases operation in AdvisorAPIApi.
 * @export
 * @interface AdvisorAPIApiAdvisorAPIListAdvisorDatabasesRequest
 */
export interface AdvisorAPIApiAdvisorAPIListAdvisorDatabasesRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof AdvisorAPIApiAdvisorAPIListAdvisorDatabases
     */
    readonly organizationId: string

    /**
     * Cache group identifier
     * @type {string}
     * @memberof AdvisorAPIApiAdvisorAPIListAdvisorDatabases
     */
    readonly cacheGroupId: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof AdvisorAPIApiAdvisorAPIListAdvisorDatabases
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof AdvisorAPIApiAdvisorAPIListAdvisorDatabases
     */
    readonly pageCursor?: string
}

/**
 * Request parameters for advisorAPIListAdvisorRecommendations operation in AdvisorAPIApi.
 * @export
 * @interface AdvisorAPIApiAdvisorAPIListAdvisorRecommendationsRequest
 */
export interface AdvisorAPIApiAdvisorAPIListAdvisorRecommendationsRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof AdvisorAPIApiAdvisorAPIListAdvisorRecommendations
     */
    readonly organizationId: string

    /**
     * Database identifier
     * @type {string}
     * @memberof AdvisorAPIApiAdvisorAPIListAdvisorRecommendations
     */
    readonly databaseId: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof AdvisorAPIApiAdvisorAPIListAdvisorRecommendations
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof AdvisorAPIApiAdvisorAPIListAdvisorRecommendations
     */
    readonly pageCursor?: string

    /**
     * Filter by recommendation kind — omit to return both query and index
     * @type {Array<'RECOMMENDATION_KIND_UNSPECIFIED' | 'RECOMMENDATION_KIND_QUERY' | 'RECOMMENDATION_KIND_INDEX'>}
     * @memberof AdvisorAPIApiAdvisorAPIListAdvisorRecommendations
     */
    readonly kinds?: Array<AdvisorAPIListAdvisorRecommendationsKindsEnum>

    /**
     * Filter by category (applies to query recommendations only)
     * @type {Array<'QUERY_RECOMMENDATION_CATEGORY_UNSPECIFIED' | 'PERFORMANCE' | 'MAINTAINABILITY' | 'CORRECTNESS' | 'SCALABILITY' | 'COST'>}
     * @memberof AdvisorAPIApiAdvisorAPIListAdvisorRecommendations
     */
    readonly categories?: Array<AdvisorAPIListAdvisorRecommendationsCategoriesEnum>

    /**
     * Filter by impact (applies to query recommendations only)
     * @type {Array<'RECOMMENDATION_IMPACT_UNSPECIFIED' | 'RECOMMENDATION_IMPACT_LOW' | 'RECOMMENDATION_IMPACT_MEDIUM' | 'RECOMMENDATION_IMPACT_HIGH'>}
     * @memberof AdvisorAPIApiAdvisorAPIListAdvisorRecommendations
     */
    readonly impacts?: Array<AdvisorAPIListAdvisorRecommendationsImpactsEnum>

    /**
     * Filter by status
     * @type {Array<'RECOMMENDATION_STATUS_UNSPECIFIED' | 'RECOMMENDATION_STATUS_OPEN' | 'RECOMMENDATION_STATUS_CLOSED'>}
     * @memberof AdvisorAPIApiAdvisorAPIListAdvisorRecommendations
     */
    readonly statuses?: Array<AdvisorAPIListAdvisorRecommendationsStatusesEnum>

    /**
     * Filter by validation status — omit to return all regardless of validation status
     * @type {Array<'RECOMMENDATION_VALIDATION_STATUS_UNSPECIFIED' | 'RECOMMENDATION_VALIDATION_STATUS_PENDING' | 'RECOMMENDATION_VALIDATION_STATUS_SUCCEEDED' | 'RECOMMENDATION_VALIDATION_STATUS_FAILED'>}
     * @memberof AdvisorAPIApiAdvisorAPIListAdvisorRecommendations
     */
    readonly validationStatuses?: Array<AdvisorAPIListAdvisorRecommendationsValidationStatusesEnum>
}

/**
 * Request parameters for advisorAPIListTopRecommendations operation in AdvisorAPIApi.
 * @export
 * @interface AdvisorAPIApiAdvisorAPIListTopRecommendationsRequest
 */
export interface AdvisorAPIApiAdvisorAPIListTopRecommendationsRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof AdvisorAPIApiAdvisorAPIListTopRecommendations
     */
    readonly organizationId: string

    /**
     * Maximum number of recommendations to return. Defaults to 5.
     * @type {number}
     * @memberof AdvisorAPIApiAdvisorAPIListTopRecommendations
     */
    readonly limit?: number
}

/**
 * Request parameters for advisorAPIMarkAdvisorDBAgentUninstalled operation in AdvisorAPIApi.
 * @export
 * @interface AdvisorAPIApiAdvisorAPIMarkAdvisorDBAgentUninstalledRequest
 */
export interface AdvisorAPIApiAdvisorAPIMarkAdvisorDBAgentUninstalledRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof AdvisorAPIApiAdvisorAPIMarkAdvisorDBAgentUninstalled
     */
    readonly organizationId: string

    /**
     * Database instance identifier
     * @type {string}
     * @memberof AdvisorAPIApiAdvisorAPIMarkAdvisorDBAgentUninstalled
     */
    readonly id: string
}

/**
 * Request parameters for advisorAPIReopenAdvisorRecommendation operation in AdvisorAPIApi.
 * @export
 * @interface AdvisorAPIApiAdvisorAPIReopenAdvisorRecommendationRequest
 */
export interface AdvisorAPIApiAdvisorAPIReopenAdvisorRecommendationRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof AdvisorAPIApiAdvisorAPIReopenAdvisorRecommendation
     */
    readonly organizationId: string

    /**
     * Database identifier
     * @type {string}
     * @memberof AdvisorAPIApiAdvisorAPIReopenAdvisorRecommendation
     */
    readonly databaseId: string

    /**
     * Recommendation identifier
     * @type {string}
     * @memberof AdvisorAPIApiAdvisorAPIReopenAdvisorRecommendation
     */
    readonly id: string
}

/**
 * Request parameters for advisorAPIResendAdvisorValidationRequest operation in AdvisorAPIApi.
 * @export
 * @interface AdvisorAPIApiAdvisorAPIResendAdvisorValidationRequestRequest
 */
export interface AdvisorAPIApiAdvisorAPIResendAdvisorValidationRequestRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof AdvisorAPIApiAdvisorAPIResendAdvisorValidationRequest
     */
    readonly organizationId: string

    /**
     * Database identifier
     * @type {string}
     * @memberof AdvisorAPIApiAdvisorAPIResendAdvisorValidationRequest
     */
    readonly databaseId: string

    /**
     * 
     * @type {ResendAdvisorValidationRequestRequestOptions}
     * @memberof AdvisorAPIApiAdvisorAPIResendAdvisorValidationRequest
     */
    readonly resendAdvisorValidationRequestRequestOptions: ResendAdvisorValidationRequestRequestOptions
}

/**
 * Request parameters for advisorAPIResetAdvisorRecommendations operation in AdvisorAPIApi.
 * @export
 * @interface AdvisorAPIApiAdvisorAPIResetAdvisorRecommendationsRequest
 */
export interface AdvisorAPIApiAdvisorAPIResetAdvisorRecommendationsRequest {
    /**
     * Organization identifier
     * @type {string}
     * @memberof AdvisorAPIApiAdvisorAPIResetAdvisorRecommendations
     */
    readonly organizationId: string

    /**
     * Database identifier
     * @type {string}
     * @memberof AdvisorAPIApiAdvisorAPIResetAdvisorRecommendations
     */
    readonly databaseId: string
}

/**
 * AdvisorAPIApi - object-oriented interface
 * @export
 * @class AdvisorAPIApi
 * @extends {BaseAPI}
 */
export class AdvisorAPIApi extends BaseAPI {
    /**
     * Returns recommendation stats for the given database IDs in a single batch call.
     * @summary Batch get advisor stats for databases
     * @param {AdvisorAPIApiAdvisorAPIBatchGetAdvisorDatabaseStatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvisorAPIApi
     */
    public advisorAPIBatchGetAdvisorDatabaseStats(requestParameters: AdvisorAPIApiAdvisorAPIBatchGetAdvisorDatabaseStatsRequest, options?: RawAxiosRequestConfig) {
        return AdvisorAPIApiFp(this.configuration).advisorAPIBatchGetAdvisorDatabaseStats(requestParameters.organizationId, requestParameters.batchGetAdvisorDatabaseStatsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Close an advisor recommendation (query or index — kind inferred from ID)
     * @summary Close an advisor recommendation
     * @param {AdvisorAPIApiAdvisorAPICloseAdvisorRecommendationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvisorAPIApi
     */
    public advisorAPICloseAdvisorRecommendation(requestParameters: AdvisorAPIApiAdvisorAPICloseAdvisorRecommendationRequest, options?: RawAxiosRequestConfig) {
        return AdvisorAPIApiFp(this.configuration).advisorAPICloseAdvisorRecommendation(requestParameters.organizationId, requestParameters.databaseId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single cache group with combined query and index recommendation statistics
     * @summary Get cache group with combined advisor statistics
     * @param {AdvisorAPIApiAdvisorAPIGetAdvisorCacheGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvisorAPIApi
     */
    public advisorAPIGetAdvisorCacheGroup(requestParameters: AdvisorAPIApiAdvisorAPIGetAdvisorCacheGroupRequest, options?: RawAxiosRequestConfig) {
        return AdvisorAPIApiFp(this.configuration).advisorAPIGetAdvisorCacheGroup(requestParameters.organizationId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single database with combined query and index recommendation statistics
     * @summary Get database with combined advisor statistics
     * @param {AdvisorAPIApiAdvisorAPIGetAdvisorDatabaseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvisorAPIApi
     */
    public advisorAPIGetAdvisorDatabase(requestParameters: AdvisorAPIApiAdvisorAPIGetAdvisorDatabaseRequest, options?: RawAxiosRequestConfig) {
        return AdvisorAPIApiFp(this.configuration).advisorAPIGetAdvisorDatabase(requestParameters.organizationId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns db-agent status for a single database instance in the organization.
     * @summary Get database instance with advisor agent status
     * @param {AdvisorAPIApiAdvisorAPIGetAdvisorDatabaseInstanceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvisorAPIApi
     */
    public advisorAPIGetAdvisorDatabaseInstance(requestParameters: AdvisorAPIApiAdvisorAPIGetAdvisorDatabaseInstanceRequest, options?: RawAxiosRequestConfig) {
        return AdvisorAPIApiFp(this.configuration).advisorAPIGetAdvisorDatabaseInstance(requestParameters.organizationId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single performance recommendation with detailed information
     * @summary Get advisor recommendation details
     * @param {AdvisorAPIApiAdvisorAPIGetAdvisorRecommendationDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvisorAPIApi
     */
    public advisorAPIGetAdvisorRecommendationDetail(requestParameters: AdvisorAPIApiAdvisorAPIGetAdvisorRecommendationDetailRequest, options?: RawAxiosRequestConfig) {
        return AdvisorAPIApiFp(this.configuration).advisorAPIGetAdvisorRecommendationDetail(requestParameters.organizationId, requestParameters.databaseId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List cache groups with combined query and index recommendation statistics
     * @summary List cache groups with combined advisor statistics
     * @param {AdvisorAPIApiAdvisorAPIListAdvisorCacheGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvisorAPIApi
     */
    public advisorAPIListAdvisorCacheGroups(requestParameters: AdvisorAPIApiAdvisorAPIListAdvisorCacheGroupsRequest, options?: RawAxiosRequestConfig) {
        return AdvisorAPIApiFp(this.configuration).advisorAPIListAdvisorCacheGroups(requestParameters.organizationId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns db-agent statuses for all database instances in the organization.
     * @summary List database instances with advisor agent status
     * @param {AdvisorAPIApiAdvisorAPIListAdvisorDatabaseInstancesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvisorAPIApi
     */
    public advisorAPIListAdvisorDatabaseInstances(requestParameters: AdvisorAPIApiAdvisorAPIListAdvisorDatabaseInstancesRequest, options?: RawAxiosRequestConfig) {
        return AdvisorAPIApiFp(this.configuration).advisorAPIListAdvisorDatabaseInstances(requestParameters.organizationId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List databases within a cache group with combined query and index recommendation statistics
     * @summary List databases with combined advisor statistics
     * @param {AdvisorAPIApiAdvisorAPIListAdvisorDatabasesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvisorAPIApi
     */
    public advisorAPIListAdvisorDatabases(requestParameters: AdvisorAPIApiAdvisorAPIListAdvisorDatabasesRequest, options?: RawAxiosRequestConfig) {
        return AdvisorAPIApiFp(this.configuration).advisorAPIListAdvisorDatabases(requestParameters.organizationId, requestParameters.cacheGroupId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List combined query and index recommendations for a database
     * @summary List combined query and index advisor recommendations
     * @param {AdvisorAPIApiAdvisorAPIListAdvisorRecommendationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvisorAPIApi
     */
    public advisorAPIListAdvisorRecommendations(requestParameters: AdvisorAPIApiAdvisorAPIListAdvisorRecommendationsRequest, options?: RawAxiosRequestConfig) {
        return AdvisorAPIApiFp(this.configuration).advisorAPIListAdvisorRecommendations(requestParameters.organizationId, requestParameters.databaseId, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.kinds, requestParameters.categories, requestParameters.impacts, requestParameters.statuses, requestParameters.validationStatuses, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the top open recommendations (query and index) across all v2  database instances in the organization, ordered by impact desc then  affected db time desc. Polyscale enriches the results with instance and  database names.
     * @summary List top recommendations across the organization
     * @param {AdvisorAPIApiAdvisorAPIListTopRecommendationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvisorAPIApi
     */
    public advisorAPIListTopRecommendations(requestParameters: AdvisorAPIApiAdvisorAPIListTopRecommendationsRequest, options?: RawAxiosRequestConfig) {
        return AdvisorAPIApiFp(this.configuration).advisorAPIListTopRecommendations(requestParameters.organizationId, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Internal-only: mark the DB agent for a cache group as uninstalled (soft  delete). Called by polyscale once the db-agent\'s Helm release has been torn  down, so that the agent\'s status resolves to NOT_INSTALLED instead of ERROR.  Not exposed to customers via the public API.
     * @summary Internal: Mark the DB agent for a cache group as uninstalled
     * @param {AdvisorAPIApiAdvisorAPIMarkAdvisorDBAgentUninstalledRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvisorAPIApi
     */
    public advisorAPIMarkAdvisorDBAgentUninstalled(requestParameters: AdvisorAPIApiAdvisorAPIMarkAdvisorDBAgentUninstalledRequest, options?: RawAxiosRequestConfig) {
        return AdvisorAPIApiFp(this.configuration).advisorAPIMarkAdvisorDBAgentUninstalled(requestParameters.organizationId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reopen a closed advisor recommendation (query or index — kind inferred from ID)
     * @summary Reopen a closed advisor recommendation
     * @param {AdvisorAPIApiAdvisorAPIReopenAdvisorRecommendationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvisorAPIApi
     */
    public advisorAPIReopenAdvisorRecommendation(requestParameters: AdvisorAPIApiAdvisorAPIReopenAdvisorRecommendationRequest, options?: RawAxiosRequestConfig) {
        return AdvisorAPIApiFp(this.configuration).advisorAPIReopenAdvisorRecommendation(requestParameters.organizationId, requestParameters.databaseId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resend validation request for advisor recommendations that don\'t already have a validation result
     * @summary Resend validation request for advisor recommendations that don\'t already have a validation result
     * @param {AdvisorAPIApiAdvisorAPIResendAdvisorValidationRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvisorAPIApi
     */
    public advisorAPIResendAdvisorValidationRequest(requestParameters: AdvisorAPIApiAdvisorAPIResendAdvisorValidationRequestRequest, options?: RawAxiosRequestConfig) {
        return AdvisorAPIApiFp(this.configuration).advisorAPIResendAdvisorValidationRequest(requestParameters.organizationId, requestParameters.databaseId, requestParameters.resendAdvisorValidationRequestRequestOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reset all advisor recommendations (query + index) for a database
     * @summary Reset all advisor recommendations for a database
     * @param {AdvisorAPIApiAdvisorAPIResetAdvisorRecommendationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvisorAPIApi
     */
    public advisorAPIResetAdvisorRecommendations(requestParameters: AdvisorAPIApiAdvisorAPIResetAdvisorRecommendationsRequest, options?: RawAxiosRequestConfig) {
        return AdvisorAPIApiFp(this.configuration).advisorAPIResetAdvisorRecommendations(requestParameters.organizationId, requestParameters.databaseId, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const AdvisorAPIListAdvisorRecommendationsKindsEnum = {
    UNSPECIFIED: 'RECOMMENDATION_KIND_UNSPECIFIED',
    QUERY: 'RECOMMENDATION_KIND_QUERY',
    INDEX: 'RECOMMENDATION_KIND_INDEX'
} as const;
export type AdvisorAPIListAdvisorRecommendationsKindsEnum = typeof AdvisorAPIListAdvisorRecommendationsKindsEnum[keyof typeof AdvisorAPIListAdvisorRecommendationsKindsEnum];
/**
 * @export
 */
export const AdvisorAPIListAdvisorRecommendationsCategoriesEnum = {
    QUERY_RECOMMENDATION_CATEGORY_UNSPECIFIED: 'QUERY_RECOMMENDATION_CATEGORY_UNSPECIFIED',
    PERFORMANCE: 'PERFORMANCE',
    MAINTAINABILITY: 'MAINTAINABILITY',
    CORRECTNESS: 'CORRECTNESS',
    SCALABILITY: 'SCALABILITY',
    COST: 'COST'
} as const;
export type AdvisorAPIListAdvisorRecommendationsCategoriesEnum = typeof AdvisorAPIListAdvisorRecommendationsCategoriesEnum[keyof typeof AdvisorAPIListAdvisorRecommendationsCategoriesEnum];
/**
 * @export
 */
export const AdvisorAPIListAdvisorRecommendationsImpactsEnum = {
    UNSPECIFIED: 'RECOMMENDATION_IMPACT_UNSPECIFIED',
    LOW: 'RECOMMENDATION_IMPACT_LOW',
    MEDIUM: 'RECOMMENDATION_IMPACT_MEDIUM',
    HIGH: 'RECOMMENDATION_IMPACT_HIGH'
} as const;
export type AdvisorAPIListAdvisorRecommendationsImpactsEnum = typeof AdvisorAPIListAdvisorRecommendationsImpactsEnum[keyof typeof AdvisorAPIListAdvisorRecommendationsImpactsEnum];
/**
 * @export
 */
export const AdvisorAPIListAdvisorRecommendationsStatusesEnum = {
    UNSPECIFIED: 'RECOMMENDATION_STATUS_UNSPECIFIED',
    OPEN: 'RECOMMENDATION_STATUS_OPEN',
    CLOSED: 'RECOMMENDATION_STATUS_CLOSED'
} as const;
export type AdvisorAPIListAdvisorRecommendationsStatusesEnum = typeof AdvisorAPIListAdvisorRecommendationsStatusesEnum[keyof typeof AdvisorAPIListAdvisorRecommendationsStatusesEnum];
/**
 * @export
 */
export const AdvisorAPIListAdvisorRecommendationsValidationStatusesEnum = {
    UNSPECIFIED: 'RECOMMENDATION_VALIDATION_STATUS_UNSPECIFIED',
    PENDING: 'RECOMMENDATION_VALIDATION_STATUS_PENDING',
    SUCCEEDED: 'RECOMMENDATION_VALIDATION_STATUS_SUCCEEDED',
    FAILED: 'RECOMMENDATION_VALIDATION_STATUS_FAILED'
} as const;
export type AdvisorAPIListAdvisorRecommendationsValidationStatusesEnum = typeof AdvisorAPIListAdvisorRecommendationsValidationStatusesEnum[keyof typeof AdvisorAPIListAdvisorRecommendationsValidationStatusesEnum];
